export default __webpack_public_path__ + "static/Earth_NormalNRM-minified-eb025b27b94b4a2a2c677ee15d05291b.jpg";